import { OrderLine, OrderLineModel } from "./models/OrderLine";

export const excelLinesToOrderLines = (rows: any[]) => {
  const orderLines = new Array<OrderLine>(rows.length);
  for (let index = 0; index < orderLines.length; index++) {
    const row = rows[index];
    orderLines[index] = new OrderLineModel(row, index + 1 /** Add one to account for header */);
  }
  return orderLines;
};
